// SKU refers to the product MSKU, but in case it is an empty string as is the case with Branded Packaging, we return the dsku as a fallback
import { Product } from "@deliverr/commons-clients";

export const getProductSku = (product: Pick<Product, "dsku" | "msku" | "packOf">) => {
  const sku = product?.packOf?.length ? product.packOf : product.dsku;

  return product.msku ? product.msku : sku;
};
